<template>
  <div v-if="required" class="requerido-tag">
    {{ $t('documentCard.required') }}
  </div>
  <div class="card-header">
    <div class="nombre-documento">
      {{ displayTitle }}
      <div v-if="withTemplateInfo" class="info-icon d-inline text-primary">
        <i class="fas fa-info-circle" :id="tooltipId"></i>
        <DxTooltip :hide-on-outside-click="false" :target="`#${tooltipId}`" show-event="mouseenter" hide-event="mouseleave">
          {{ $t("documentCard.templateTooltipMsg") }}
        </DxTooltip>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { DxTooltip } from 'devextreme-vue';
import _ from 'lodash';

const props = defineProps<{
  title: string;
  required: boolean;
  additionalMsg: string | null;
  withTemplateInfo?: boolean;
}>();

const tooltipId = _.uniqueId("tooltip-document-card-header-with-template-info-");

// Esto no se tendría que resolver así, no tiene sentido una segunda propiedad para terminar concatenando el mensaje adicional con el título
// Para eso lo pones directamente concatenado y fuera. Lo suyo es que este mensaje adicional se mostrar como un tooltip
const displayTitle = computed(() => {
  return props.additionalMsg
    ? `${props.title} (${props.additionalMsg})`
    : props.title;
});

</script>

<style scoped lang="scss">


.card-header {
  padding: 1.275rem 0.35rem 0.5rem;
  text-align: left;
  flex: 0 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.document-card--horizontal .card-header {
  padding: 0 1rem;
  max-width: 35%;
  align-self: center;

}

.card-header .nombre-documento {
  color: var(--text-default-caption, #667790);
  font-size: var(--font-size-body-md);
  font-style: normal;
  font-weight: 700;
  text-align: center;
  width: 100%;
}

.document-card--horizontal .card-header .nombre-documento {
  text-align: left;
}

.required-tag {
  background-color: var(--background-error-default);
  color: white;
  font-weight: bold;
  padding: 0.2rem 0.6rem;
  border-radius: 5px;
}

.info-icon {
  margin-left: auto;
  font-size: 20px;
  cursor: pointer;
  position: relative;
}

.tooltip {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--background-normal-dark);
  color: var(--text-default-inverse);
  padding: 5px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.card-title {
  margin: 0;
  font-size: 1.25rem;
}

.requerido-tag {
  background: var(--background-primary-default);
  left: calc(100% - 44px);
  transform: translate(-50%, -50%) !important;
  position: absolute;
  top: 0;
  font-weight: 700;
  color: var(--text-default-inverse);
  font-size: .75em;
  padding: 0.35rem 0.65rem;
  border-radius: 0.375em;
  line-height: 1;
}

.notValid {
  border: 3px solid var(--border-error-default);

  .requerido-tag {
    background: var(--background-error-default);
  }
}

.start-85 {
  left: 85%;
}
</style>